import { useEffect, useRef, useState } from "react";

let ctx;
const getCtx = () => {
    if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    return ctx;
};

let introAudio;
export function playSound() {
    try {
        window.__dings = (window.__dings || 0) + 1;
        getCtx();
        if (!introAudio) {
            introAudio = new Audio("/netflix-intro.mp3");
            introAudio.preload = "auto";
        }
        introAudio.currentTime = 0;
        introAudio.volume = 0.9;
        const p = introAudio.play();
        if (p && p.catch) p.catch(() => {});
    } catch {}
}

export function useSoundOn() {
    const [on, setOn] = useState(() => localStorage.getItem("refundaja-sound") !== "off");
    const toggle = () => {
        const next = !on;
        localStorage.setItem("refundaja-sound", next ? "on" : "off");
        window.dispatchEvent(new Event("refundaja-sound"));
        setOn(next);
    };
    useEffect(() => {
        const h = () => setOn(localStorage.getItem("refundaja-sound") !== "off");
        window.addEventListener("refundaja-sound", h);
        return () => window.removeEventListener("refundaja-sound", h);
    }, []);
    return [on, toggle];
}

export function useResultSound(value, enabled) {
    const prev = useRef(null);
    useEffect(() => {
        if (value === null || value === undefined) {
            prev.current = null;
            return;
        }
        if (value === prev.current) return;
        const id = setTimeout(() => {
            prev.current = value;
            if (enabled) playSound();
        }, 420);
        return () => clearTimeout(id);
    }, [value, enabled]);
}
